import { useTheme } from '@mui/material';
import { Field } from 'formik';
import { CheckboxWithLabel } from 'formik-mui';

interface CustomCheckboxProps {
  setOpenDialog: (dialogType: string) => void;
}

const BreadMultiCheckbox: React.FC<CustomCheckboxProps> = ({ setOpenDialog }) => {
  const theme = useTheme();
  const handleOpenDialog = (dialogType: string) => {
    setOpenDialog(dialogType);
  };
  return (
    <Field
      component={CheckboxWithLabel}
      type="checkbox"
      name={'multi_check'}
      Label={{
        label: (
          <>
            <button
              type="button"
              onClick={() => handleOpenDialog('terms')}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                textDecoration: 'underline',
                color: theme.palette.info.main,
                cursor: 'pointer',
                fontSize: 'inherit',
                fontFamily: 'inherit',
              }}
            >
              Terms & Conditions
            </button>
            ,{' '}
            <button
              type="button"
              onClick={() => handleOpenDialog('customerNotice')}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                textDecoration: 'underline',
                color: theme.palette.info.main,
                cursor: 'pointer',
                fontSize: 'inherit',
                fontFamily: 'inherit',
              }}
            >
              Customer Notice
            </button>
            ,{' '}
            <button
              type="button"
              onClick={() => handleOpenDialog('privacyPolicy')}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                textDecoration: 'underline',
                color: theme.palette.info.main,
                cursor: 'pointer',
                fontSize: 'inherit',
                fontFamily: 'inherit',
              }}
            >
              Privacy Policy
            </button>
            ,{' '}
            <button
              type="button"
              onClick={() => handleOpenDialog('psgTC')}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                textDecoration: 'underline',
                color: theme.palette.info.main,
                cursor: 'pointer',
                fontSize: 'inherit',
                fontFamily: 'inherit',
              }}
            >
              Premier Service Group Terms & Conditions
            </button>
          </>
        ),
      }}
    />
  );
};

export default BreadMultiCheckbox;
